'use strict';
/* eslint-disable */

var cssConstants = {
    HIDDEN_CLASS: 'is--hidden',
    IGNORE_CLASS: 'js-ignore'
}

function initializeEvents() {
    $('.js-accept-discount').change(function(){
        let acceptDiscount = $(this).prop('checked');
        $('.js-newsletter-discount-form').toggleClass(cssConstants.HIDDEN_CLASS + ' ' + cssConstants.IGNORE_CLASS, !acceptDiscount);
        if (!acceptDiscount) {
            $('.js-newsletter-policy').prop('checked', false);
            $('.js-gender-newsletter-women').prop('checked', false);
            $('.js-gender-newsletter-men').prop('checked', false);
            $('.js-gender-newsletter-junior').prop('checked', false);
        }
    });
    $('.js-newsletter-policy').change(function(){
        let newsletterPolicy = $(this).prop('checked');
        if (newsletterPolicy) {
            $('.show-read-more-registration').removeClass('show-read-more-error-border');
        }else{
            $('.show-read-more-registration').addClass('show-read-more-error-border');
        }
    });
    $('.js-privacy-policy').change(function(){
        let privacyPolicy = $(this).prop('checked');
        if (privacyPolicy) {
            $('.c-confirmation-register__button').removeClass('disabled');
        }else{
            $('.c-confirmation-register__button').addClass('disabled');
        }
    });
    $('#confirmation-register-button').click(function(){
        let acceptDiscount = $('#RegistrationForm').find('.newsletter-section .js-accept-discount').is(':checked');
        let newsletterPolicy = $('#RegistrationForm').find('.newsletter-section .js-newsletter-policy').is(':checked');
        if(acceptDiscount && !newsletterPolicy){
            $('#RegistrationForm .newsletter-section .show-read-more-registration').addClass('show-read-more-error-border');
        }
    });
    $('.js-phone-input').blur(function(){
        let phoneInputValue = $(this).prop('value');
        if(!phoneInputValue){
            $('.js-phone-input').removeClass('valid');
        } 
    });
}
var registeraccount = {
    init: function () {
        initializeEvents();
        $('#dwfrm_profile_customer_gender').val('3').trigger('change');
    }
};

module.exports = registeraccount;